import "./TimeFilter.scss";
import FilterSelect from "../FilterSelect";
import MonthRangeDropdown from "../MonthRangeDropdown";
import { useState, useEffect } from "react";
import { faCalendar } from "@fortawesome/free-solid-svg-icons";

function TimeFilter({
  label,
  width = "half",
  startDate,
  filterValue,
  options,
  selectedValue,
  onChange,
  open,
  monthRangeValue,
  onApply,
  onCancel,
  disabled = false,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [openMonthRange, setOpenMonthRange] = useState(false);

  const handleIsOpen = (selectedValue) => {
    if (selectedValue === "custom") {
      setOpenMonthRange(true);
    }
    // if (selectedValue === "custom" && isOpen) return;
    setIsOpen((prev) => !prev);
  };

  const handleOnApply = ({ from, to }) => {
    // setIsOpen(false);
    setOpenMonthRange(false);
    onApply({ from, to });
  };

  const handleCancle = () => {
    onCancel();
    setOpenMonthRange(false);
  };

  //Open Month Range
  useEffect(() => {
    if (filterValue === "custom") {
      setOpenMonthRange(true);
    }
  }, [filterValue]);

  //Close Month Range if Dropdown is open
  useEffect(() => {
    if (isOpen) {
      // setOpenMonthRange(false);
    }
  }, [isOpen]);

  return (
    <>
      <FilterSelect
        label={label}
        icon={faCalendar}
        value={selectedValue?.label || options[0]?.label}
        // value={filterValue}
        options={options}
        onChange={onChange}
        handleIsOpen={handleIsOpen}
        width={width}
        disabled={disabled || openMonthRange}
      />
      {openMonthRange && (
        <MonthRangeDropdown
          open={true}
          startDate={startDate}
          //   open={open}
          value={monthRangeValue}
          onApply={handleOnApply}
          //   onApply={onApply}
          onCancel={handleCancle}
        />
      )}
      {/* {isOpen && filterValue === "custom" && (
        <MonthRangeDropdown
          open={true}
          //   open={open}
          value={monthRangeValue}
          onApply={handleOnApply}
          //   onApply={onApply}
          onCancel={onCancel}
        />
      )} */}
    </>
  );
}

export default TimeFilter;
